import { render, staticRenderFns } from "./ShowTicket.vue?vue&type=template&id=05cfa752&scoped=true&"
import script from "./ShowTicket.vue?vue&type=script&lang=js&"
export * from "./ShowTicket.vue?vue&type=script&lang=js&"
import style0 from "./ShowTicket.vue?vue&type=style&index=0&id=05cfa752&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cfa752",
  null
  
)

export default component.exports